module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/energy/energy-tab/energy-tab.component.scss
// module id = ./src/app/entities/energy/energy-tab/energy-tab.component.scss
// module chunks = main